import { indexItems } from '@/mocks/siteData';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', border: 'border-primary-200 hover:border-primary-300' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', border: 'border-accent-200 hover:border-accent-300' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', border: 'border-secondary-200 hover:border-secondary-300' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            专题索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">按话题分类浏览，快速找到你感兴趣的影视八卦</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => {
            const cm = colorMap[item.color] || colorMap.primary;
            return (
              <a
                key={i}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`group flex items-center gap-4 p-4 md:p-5 bg-background-50 border rounded-xl transition-all cursor-pointer ${cm.border}`}
              >
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${cm.bg}`}>
                  <i className={`${item.icon} text-lg ${cm.text}`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-0.5">
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900">
                      {item.title}
                    </h3>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${cm.bg} ${cm.text} whitespace-nowrap`}>
                      {item.count}篇
                    </span>
                  </div>
                  <p className="text-foreground-500 text-xs truncate">{item.desc}</p>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}